import { render, staticRenderFns } from "./xzrmblist.vue?vue&type=template&id=505150c4&scoped=true"
import script from "./xzrmblist.vue?vue&type=script&lang=js"
export * from "./xzrmblist.vue?vue&type=script&lang=js"
import style0 from "./xzrmblist.vue?vue&type=style&index=0&id=505150c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505150c4",
  null
  
)

export default component.exports